import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import { uniqueId } from 'lodash';
import Translate from '../common/Translate';
import ModalCustomCost from '../FormElement/ModalCustomCost';
import useValue from '../../services/Form/useValue';

const CarDamageButton = (props) => {
  const { questionId, sectionId, formId, zone, resetState } = props;
  const [value, setValue] = useValue(
    formId,
    sectionId,
    questionId,
    'questionType',
    `children.${zone.id}.value`,
    '',
    zone.id,
    zone.type,
  );
  const [customCostModalShown, setCustomCostModalShown] = useState(false);

  let customCostKey = [];
  if (Array.isArray(zone.custom_cost)) customCostKey = zone.custom_cost;

  const buttons = zone.options;

  const onClick = (button) => {
    if (customCostKey.includes(button)) return setCustomCostModalShown(true);
    if (button === value) return setValue(null);
    setValue(button).then(() => resetState('option'));
    return true;
  };

  const closeModal = () => {
    setCustomCostModalShown(false);
  };

  const setCustomValues = (values) => {
    setValue(values);
    closeModal();
    resetState('option');
  };

  return (
    <>
      <ModalCustomCost
        isOpen={customCostModalShown}
        closeModal={closeModal}
        setCustomValues={setCustomValues}
        customCostKey={customCostKey}
        value={value}
        questionId={questionId}
      />
      <Container fluid>
        <div className="button-damage-wrapper">
          <Row>
            {buttons.map((button, key) => (
              <Col xs="6" key={uniqueId(key)}>
                <button
                  type="button"
                  data-cy={button}
                  data-test={`${zone.id}-${button}-button`}
                  className={
                    value !== null &&
                    (value === button ||
                      (typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, button)))
                      ? 'btn btn-value selected'
                      : 'btn btn-value'
                  }
                  onClick={() => onClick(button)}
                >
                  <Translate code={button} />
                </button>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </>
  );
};

export default CarDamageButton;

CarDamageButton.propTypes = {
  zone: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    id: PropTypes.string.isRequired,
    custom_cost: PropTypes.shape(),
    options: PropTypes.shape().isRequired,
    type: PropTypes.string.isRequired,
  }),
  // setValue: PropTypes.func,
  questionId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  formId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  resetState: PropTypes.func.isRequired,
};

CarDamageButton.defaultProps = {
  zone: {
    custom_cost: undefined,
  },
};
